// extracted by mini-css-extract-plugin
export var content = "_b3-3";
export var list = "_b3-4";
export var settingsContent = "_b3-7";
export var settingsPanel = "_b3-8";
export var state = "_b3-6";
export var triggerBadge = "_b3-2";
export var triggerButton = "_b3-1";
export var triggerShell = "_b3-0";
export var unreadDot = "_b3-5";